import BaseListStore from 'stores/BaseListStore';
import DwellTimeStore, { IDwellTime } from 'stores/dwellTime/DwellTimeStore';
import { SortDirection } from 'constants/SortDirection';
import { buildOptions, get, getPage } from 'stores/_services/dataService';
import { observable, makeObservable } from 'mobx';
import { IDataFetchOptions } from '../../types';
import { getConditions } from 'stores/_services/filterService';
import { buildCsvDownloadUrl } from 'stores/_services/downloadService';

const TOP_ITEMS_LIMIT = 10;
const SEARCH_FIELDS = ['fileRepId', 'name', 'variantType', 'threatName'];

export default class DwellTimeListStore extends BaseListStore<DwellTimeStore> {
    topDwellTimeItemIds = [];

    constructor() {
        super({
            itemStore: DwellTimeStore,
            sortBy: 'dwellDays',
            sortDirection: SortDirection.DESC
        });

        makeObservable(this, {
            topDwellTimeItemIds: observable
        });
    }

    get topDwellTimeItems(): IDwellTime[] {
        return this.topDwellTimeItemIds.map((id) => this.data.get(id)?.dwellTime);
    }

    async getTopDwellTimeItems(): Promise<void> {
        const options = {
            filter: {
                order: 'dwell_days DESC',
                limit: TOP_ITEMS_LIMIT
            }
        };

        const { data } = await get('fileDwellTimes', options);

        this._updateData(data);
        this._updateIds(data, 0, this.topDwellTimeItemIds);
    }

    async getDwellTimeItems(args: IDataFetchOptions = {}): Promise<void> {
        const shouldReset = this._updateListState(args);
        const conditions = getConditions(this.filter);

        const options = {
            filter: {
                limit: this.limit,
                skip: this.skip,
                searchFields: SEARCH_FIELDS,
                where: conditions,
                order: this.sort
            }
        };

        const { data } = await getPage('fileDwellTimes', options);

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data, this.skip);
        this._updateCount(data);
    }

    async exportToCsv(): Promise<void> {
        const conditions = getConditions(this.filter);

        const options = {
            filter: {
                order: this.sort,
                where: conditions,
                searchFields: SEARCH_FIELDS
            },
            excludeFields: ['id', 'fileRepId', 'flagId', 'variantId']
        };

        const query = buildOptions(options);

        window.location.href = await buildCsvDownloadUrl('fileDwellTimes', query);
    }
}
